<template>
  <div class="p-3">

   <ListHistory />

   <b-alert show variant="light" class="text-right">
    <p class="m-0 text-xs">Propósito, parametrizar configuraciones por países.</p>
   </b-alert>

  </div>
</template>

<script>

// Componentes
import ListHistory from './fragments/ListHistory.vue';

export default {

  name: "AdministrationCountriesIndex",

  components: {
    ListHistory
  },

};
</script>

<style scoped></style>
